<template>
  <!-- ROW 1 -->
  

  <!-- ROW 2 -->
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2 && detailedView"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2 && detailedView"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  >
    Offense
  </th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2 && detailedView"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  ></th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2 && detailedView"
    scope="col"
    class="border-0   fw-bold m-0"
    style="z-index: 500"
  >
    Sentenced
  </th>

  <!-- ROW 3 -->
  <th
    :class="detailedView? '' :'fs-5'" v-if="row == 3" class="border-0 fw-bold pl-5 pr-0 special-width" style="height: 58px;">
    Count
  </th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Type
  </th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3"
    scope="col"
    class="border-0 fw-bold m-0 pl-3 "
    style="z-index: 500; min-width: 170px;"
  >
    Statute
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3"
    scope="col"
    class="border-0 fw-bold m-0 pl-0"
    style="z-index: 500"
  >
    Description
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Date
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3"
    scope="col"
    class="border-0 fw-bold m-0 pl-0 "
    style="z-index: 500"
  >
    Severity
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Status
  </th>

  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Per
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 2 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Subordinate
  </th>
  <th
    :class="detailedView? '' :'fs-5'"
    v-if="row == 3 && detailedView"
    scope="col"
    class="border-0 fw-bold m-0 "
    style="z-index: 500"
  >
    Ratio
  </th>
</template>
 
<script>
export default {
  props: ["row", "toggleView", "detailedView"],

  emits: ["displayLawText", "chargeStatusChange"],
  data() {
    return {
      toggleView: "toggleIncarceration",
      toggleViewText: "Incarceration",
    };
  },

  methods: {
    // toggleConsequences() {
    //   this.toggleView = "toggleConsequences";
    //   this.toggleViewText = "Consequences";
    //   // console.log('BING')
    //   this.$emit("onToggleView", {
    //     toggleView: this.toggleView,
    //     toggleViewText: this.toggleViewText,
    //   });
    // },

    // toggleIncarceration() {
    //   this.toggleView = "toggleIncarceration";
    //   this.toggleViewText = "Incarceration";

    //   this.$emit("onToggleView", {
    //     toggleView: this.toggleView,
    //     toggleViewText: this.toggleViewText,
    //   });
    // },

    // toggleDetails() {
    //   this.toggleView = "toggleDetails";
    //   this.toggleViewText = "Details";

    //   this.$emit("onToggleView", {
    //     toggleView: this.toggleView,
    //     toggleViewText: this.toggleViewText,
    //   });
    // },

    // toggleGroups() {
    //   this.toggleView = "toggleGroups";
    //   this.toggleViewText = "Groups";

    //   this.$emit("onToggleView", {
    //     toggleView: this.toggleView,
    //     toggleViewText: this.toggleViewText,
    //   });
    // },
  },

  mounted() {},
};
</script>

<style scoped>
.dropdown-menu {
  /* position: fixed !important; */
  z-index: 999999999999 !important;
  background-color: var(--secondary) !important;
}

.z-high {
  z-index: 1000000;
}


</style>
